import { render, staticRenderFns } from "./NewDutyNotice.vue?vue&type=template&id=3fecf334&"
import script from "./NewDutyNotice.vue?vue&type=script&lang=js&"
export * from "./NewDutyNotice.vue?vue&type=script&lang=js&"
import style0 from "./NewDutyNotice.vue?vue&type=style&index=0&id=3fecf334&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports